import { FormControlLabel, FormGroup } from "@mui/material";
import { observer } from "mobx-react-lite";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import BriaCheckbox from "../../../../components/common/BriaCheckbox/BriaCheckbox";
import BriaTooltip from "../../../../components/common/BriaTooltip/BriaTooltip.tsx";
import { useAppStore } from "../../../../hooks/useStores.tsx";
import { OrgFeatures } from "../../../../models/billing.ts";
import { IframePages } from "../../../../models/new-iframe";
import iframeStore from "../../iframe-store.tsx";

const IframeAvailablePages = () => {
	const { t } = useTranslation("translation", { keyPrefix: "newIframes.editor.form.availablePages" });
	const { iframeForm, handleFormChange } = iframeStore;
	const { authStore } = useAppStore();
	const featureChecks: Partial<Record<IframePages, OrgFeatures>> = {
		automotive: OrgFeatures.AUTOMOTIVE,
		campaign: OrgFeatures.CAMPAIGN,
	};
	const handlePageChange = (page: IframePages, checked: boolean) => {
		handleFormChange("config", {
			...iframeForm.config,
			enabled_pages: { ...iframeForm.config.enabled_pages, [page]: checked },
		});
	};

	const isFeatureEnabled = (page: IframePages) => {
		const feature = featureChecks[page];
		return !feature || authStore.isFeatureEnabled(feature);
	};

	useEffect(() => {
		if (!authStore.isLoadingOrgSubscriptions && authStore.orgSubscription) {
			Object.keys(iframeStore.iframeForm.config.enabled_pages).forEach((page: string) => {
				const key = page as keyof typeof iframeStore.iframeForm.config.enabled_pages;
				iframeStore.iframeForm.config.enabled_pages[key] = isFeatureEnabled(key);
			});
		}
	}, [authStore.orgSubscription, authStore.isLoadingOrgSubscriptions]);

	return (
		<FormGroup>
			{Object.entries(iframeForm.organization.allowed_pages)
				.map(([page]) => page)
				.sort(iframeStore.sortPages)
				.map((page) => (
					<BriaTooltip
						disable={!featureChecks[page as IframePages] || isFeatureEnabled(page as IframePages)}
						title={t("upgradeYourSubscription")}
					>
						<FormControlLabel
							key={page}
							control={
								<BriaCheckbox
									checked={iframeForm.config.enabled_pages?.[page as IframePages]}
									onChange={(e) => handlePageChange(page as IframePages, e.target.checked)}
									disabled={!isFeatureEnabled(page as IframePages)}
								/>
							}
							label={iframeStore.getIframeAppName(page as IframePages)}
						/>
					</BriaTooltip>
				))}
		</FormGroup>
	);
};

export default observer(IframeAvailablePages);
